var facebook = "//s3.amazonaws.com/edge-assets.lemonade.com/facebook-0ef4315d24cb5fda4c744e8e33ad179e.svg";

export { facebook as default };
